import { type Maybe } from 'dibs-ts-utils/exports/Maybe.ts';
import { useFragment, graphql } from 'react-relay';
import {
    type useTrackedAuctionType_item$key,
    type VerticalType,
} from './__generated__/useTrackedAuctionType_item.graphql.ts';

type Props = {
    item: useTrackedAuctionType_item$key | null | undefined;
};

export const useTrackedAuctionType = ({ item: itemRef }: Props): string => {
    const item = useFragment(
        graphql`
            fragment useTrackedAuctionType_item on Item {
                vertical
                getCategoriesByLevel(level: 1) {
                    name
                }
            }
        `,
        itemRef
    );
    const { vertical, getCategoriesByLevel } = item || {};
    const L1Category = getCategoriesByLevel?.[0]?.name;

    return `${vertical}/${L1Category}`;
};

export const getTrackedAuctionType = (vertical: Maybe<VerticalType>, L1Category: string): string =>
    `${vertical}/${L1Category}`;
